import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { formClass } from './styles';

var FieldError =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(FieldError, _PureComponent);

  var _super = _createSuper2(FieldError);

  function FieldError() {
    _classCallCheck(this, FieldError);

    return _super.apply(this, arguments);
  }

  _createClass(FieldError, [{
    key: "render",
    value: function render() {
      var error = this.props.error; // eslint-disable-next-line

      if (Array.isArray(error)) error = error[0];
      if (!(error instanceof Error)) return null;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: formClass('error')
        }, error.message)
      );
    }
  }]);

  return FieldError;
}(PureComponent);

export default FieldError;